var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ viewBox: "0 0 40.53 40.53" }, props),
    React.createElement("path", { className: styles["oc-icon-product"] || "oc-icon-product", d: "M37.1 20.36h-3.32a.71.71 0 0 0-.47.12 6.55 6.55 0 0 0-4.26-1.66A6.23 6.23 0 0 0 24.2 21a5.68 5.68 0 0 0-3.79-1.3 5 5 0 0 0-3.66 1.3 6.07 6.07 0 0 0-4.73-2 6.49 6.49 0 0 0-4.38 1.6.71.71 0 0 0-.47-.12H3.86a1.19 1.19 0 0 0-1.18 1.18 1.12 1.12 0 0 0 1.18 1.18h2.36A3 3 0 0 0 6 24c0 2.84 2.72 5.2 5.91 5.2s5.91-2.37 5.91-5.2a2.31 2.31 0 0 0-.12-.95A2.86 2.86 0 0 1 20.3 22a4.14 4.14 0 0 1 2.84.95A3.27 3.27 0 0 0 23 24c0 2.84 2.72 5.2 5.91 5.2s5.91-2.37 5.91-5.2a4.25 4.25 0 0 0-.24-1.3H37a1.19 1.19 0 0 0 1.18-1.18 1.09 1.09 0 0 0-1.08-1.16zM12 26.87c-2 0-3.67-1.3-3.67-2.84S10 21.19 12 21.19s3.67 1.3 3.67 2.84S14 26.87 12 26.87zm17 0c-2 0-3.67-1.3-3.67-2.84s1.66-2.84 3.67-2.84 3.67 1.3 3.67 2.84-1.61 2.84-3.62 2.84z" })
  );
});


// WEBPACK FOOTER //
// ./icons/images/products/Inspector.svg